// Library Imports
import React, { Component } from "react";
import ReactTable from "react-table";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import * as moment from "moment";
import loadable from "@loadable/component";
// Service Imports
import { LookUpService } from "../../services/lookupService";
import { ExcelService } from "../Excel/excel";
// Other Imports
import { PopUpPortal } from "../../containers/popups/PopUpPortal";
import {
  warning,
  warningNotification,
} from "../../components/notification/notifications";
import LoadingFallback from '../../components/loadingFallBack'

// Lazy-loaded components
const OpsHeader = loadable(() => import("../../components/dashboardheader/dashboardheader"), {
  fallback: <LoadingFallback />,
});
const FinxFooter = loadable(() => import("../../containers/finxfooter/finxfooter"), {
  fallback: <LoadingFallback />,
});

class CamsEuinErrorReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorReportList: [],
      fromDate: "",
      toDate: "",
      formattedFromDate: "",
      formattedToDate: "",
      loading: false,
      showTable: true,
    };
    this.showAll = this.showAll.bind(this);
  }

  componentDidMount() {
    this.initializeDefaultDates();
  }

  initializeDefaultDates = () => {
    let endDate = new Date();
    let startDate = new Date();
    // Set default date range to 1 year
    startDate.setFullYear(endDate.getFullYear() - 1);

    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    };

    let dateFormatter = new Intl.DateTimeFormat("en-IN", options);
    let fromDate = dateFormatter.format(startDate);
    let toDate = dateFormatter.format(endDate);

    let formattedFromDate = `${fromDate.split("/")[2]}-${fromDate.split("/")[1]
      }-${fromDate.split("/")[0]}`;
    let formattedToDate = `${toDate.split("/")[2]}-${toDate.split("/")[1]}-${toDate.split("/")[0]
      }`;

    this.setState({
      fromDate: fromDate,
      toDate: toDate,
      formattedFromDate,
      formattedToDate
    }, () => {
      this.fetchReportData();
    });
  }

  fetchReportData = (fromDate, toDate) => {
    let params = "";
    if (fromDate) params += `fromDate=${fromDate}`;
    if (toDate) params += (params ? "&" : "") + `toDate=${toDate}`;

    this.setState({ loading: true });

    LookUpService.getCamsEuinErrorReport(params, (res) => {
      if (res.status === "success") {
        this.setState({
          loading: false,
          errorReportList: res.responseListObject || [],
          showTable: true
        });
      } else {
        warning(res.reasonText || "Failed to fetch report data", warningNotification);
        this.setState({
          loading: false,
          errorReportList: [],
          showTable: true
        });
      }
    });
  }


  showAll = () => {
    this.initializeDefaultDates();
  }

  handleReset = (resetForm) => {
    // Clear the form values
    resetForm();

    // Clear the report data and hide table
    this.setState({
      errorReportList: [],
      showTable: false,
      loading: false
    });
  };

  filterCaseInsensitive = ({ id, value }, row) => {
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(value.toLowerCase())
      : true;
  };

  exportToCSV = () => {
    let modifiedData = [];
    let data = this.state.errorReportList;

    if (data.length > 0) {
      data.forEach((element) => {
        var data1 = {
          "PAN Number": element.panNo ? element.panNo : "---",
          // "Status": element.status ? element.status : "---",
          "Message": element.message ? element.message : "---",
          "Entry Date": element.entryDate ? element.entryDate : "---",
        };
        modifiedData.push(data1);
      });
      ExcelService.ExcelData(modifiedData, "CAMS_EUIN_Error_Report-");
    } else {
      warning("No records found to export", warningNotification);
    }
  };

  getMinDate = () => {
    return "2000-01-01"; // allow selection starting from year 2000
  };

  getMaxDate = () => {
    const today = new Date();
    return today.toISOString().split("T")[0]; // e.g. "2025-08-19"
  };



  render() {
    const { fromDate, toDate, formattedFromDate, formattedToDate, loading, showTable, errorReportList } = this.state;

    return (
      <React.Fragment>
        {loading && (
          <PopUpPortal
            HidePopup={loading}
            IsVisible={loading}
          />
        )}

        <OpsHeader {...this.props} />

        <section className="dashboard-tab user-tab pt-80 mb-50">
          <div className="padding-rl-50">
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12 col-sm-12 col-xs-12">
                  <div className="table-header">
                    <h3>
                      <div className="row">
                        <div className="col-md-8 col-sm-6 col-xs-10">
                          <span className="left-icon">
                            <i className="fa fa-list" aria-hidden="true"></i>
                          </span>{" "}
                          CAMS EUIN Error Report
                        </div>
                        <div className="col-md-4 col-sm-6 col-xs-2">
                          <span className="right-icon">
                            <a href="#">
                              <i
                                onClick={() => this.exportToCSV()}
                                className="fa fa-file-excel-o"
                                aria-hidden="true"
                                title="Export to excel"
                              ></i>
                            </a>
                          </span>
                        </div>
                      </div>
                    </h3>
                  </div>

                  <div className="bg-box">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        fromDate: "",
                        toDate: "",
                      }}

                      validationSchema={Yup.object().shape({
                        fromDate: Yup.string()
                          .nullable()
                          .test(
                            "fromDate-required-if-toDate",
                            "From Date is required",
                            function (value) {
                              const { toDate } = this.parent;
                              if (toDate && !value) return false; // require fromDate if toDate is filled
                              return true;
                            }
                          )
                        ,

                        toDate: Yup.string()
                          .nullable()
                          .test(
                            "toDate-required-if-fromDate",
                            "To Date is required",
                            function (value) {
                              const { fromDate } = this.parent;
                              if (fromDate && !value) return false; // require toDate if fromDate is filled
                              return true;
                            }
                          )
                      })}



                      onSubmit={(values) => {
                        // Case 1: No dates selected
                        if (!values.fromDate && !values.toDate) {
                          this.fetchReportData(); // call API with no date params
                          return;
                        }

                        // Case 2: Validation - if fromDate > toDate
                        if (values.fromDate && values.toDate) {
                          const fromDate = new Date(values.fromDate);
                          const toDate = new Date(values.toDate);

                          if (fromDate > toDate) {
                            warning("From Date should be less than or equal to To Date", warningNotification);
                            return;
                          }
                        }

                        // Case 3: Proceed with API call with selected values
                        this.fetchReportData(values.fromDate, values.toDate);
                      }}

                      render={({ handleSubmit, handleChange, resetForm, values }) => (
                        <Form onSubmit={handleSubmit} className="">
                          <div className="row">
                            <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                              <div className="filter">
                                <div className="form-group">
                                  <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12 pl pr">
                                    <h5 className="filter-heading">
                                      Search Criteria
                                    </h5>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        From Date
                                      </label>
                                      <Field
                                        type="date"
                                        name="fromDate"
                                        id="fromDate"
                                        className="custom-input"
                                        min={this.getMinDate()} // Set min date to 1 year ago
                                        max={this.getMaxDate()} // Set max date to today
                                        onChange={handleChange}
                                        placeholder="dd/mm/yyyy"
                                      />
                                      <ErrorMessage
                                        name="fromDate"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                    <div className="col-md-4 col-sm-4 col-xs-12">
                                      <label>
                                        To Date
                                      </label>
                                      <Field
                                        type="date"
                                        name="toDate"
                                        id="toDate"
                                        className="custom-input"
                                        min={this.getMinDate()} // Min is either fromDate or 1 year ago
                                        max={this.getMaxDate()} // Max is today
                                        onChange={handleChange}
                                        placeholder="dd/mm/yyyy"
                                      />

                                      <ErrorMessage
                                        name="toDate"
                                        component="div"
                                        className="validation"
                                      />
                                    </div>
                                  </div>
                                  <div className="row">
                                    <div className="col-md-12 col-sm-12 mt-40">
                                      <button
                                        className="btn-5 mr-20 ml-20"
                                        type="submit"
                                      >
                                        Search
                                      </button>
                                      <button
                                        className="btn-5"
                                        type="button"
                                        onClick={() => this.handleReset(resetForm)}
                                      >
                                        Reset
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Form>
                      )}
                    />

                    {showTable && (
                      <div className="table-responsive">
                        <ReactTable
                          minRows={2}
                          data={errorReportList || []}
                          filterable
                          defaultFilterMethod={this.filterCaseInsensitive}
                          columns={[
                            {
                              columns: [
                                {
                                  Header: "PAN Number",
                                  id: "panNumber",
                                  accessor: (d) =>
                                    (d.panNo ? d.panNo : "---").toString(),
                                },
                                // {
                                //   Header: "Status",
                                //   id: "status",
                                //   accessor: (d) =>
                                //     (d.status ? d.status : "---").toString(),
                                // },
                                {
                                  Header: "Message",
                                  id: "message",
                                  accessor: (d) =>
                                    (d.message ? d.message : "---").toString(),
                                }, {
                                  Header: "Entry Date",
                                  id: "entryDate",
                                  filterable: false,
                                  accessor: (d) => d.entryDate || "---",
                                  Cell: (row) => row.value || "---",
                                }
                                ,
                              ],
                            },
                          ]}
                          defaultPageSize={10}
                          style={{
                            width: "100%",
                            maxHeight: "500px",
                          }}
                        />
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <FinxFooter />
      </React.Fragment>
    );
  }
}

export default CamsEuinErrorReport;